<template>
  <div :class="computedClass">
    <JadeText
      color="current-color"
      variant="text-medium"
      weight="medium"
      as="label"
      :for="htmlFor"
    >
      <slot></slot>
    </JadeText>

    <span
      v-if="optional"
      class="jade-label__optional-indicator"
    >
      <JadeText
        color="current-color"
        variant="text-small"
        weight="regular"
        as="span"
      >
        Opcional
      </JadeText>
    </span>
  </div>
</template>

<script>
import JadeText from '../JadeText'
export default {
  name: 'JadeLabel',
  components: {
    JadeText
  },
  props: {
    htmlFor: String,
    error: Boolean,
    disabled: Boolean,
    hidden: Boolean,
    optional: Boolean
  },
  computed: {
    computedClass () {
      return {
        'jade-label': true,
        'is-errored': this.error,
        'is-disabled': this.disabled,
        'is-hidden': this.hidden
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/label.css';
</style>
